import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import modalsContainerSelector from '../../selectors/modal/ModalsContainerSelector';
import OneWayConfirmationModal from './OneWayConfirmationModal';
import OneWayNavigationOfflineModal from './OneWayNavigationOfflineModal';
import TalviewInitAllocatedTimePassedModal from './TalviewInitAllocatedTimePassedModal';
import SecondScreenDetectedModal from './SecondScreenDetectedModal';

const ModalsContainer = (props) => {
    const {
        shouldRenderOneWayNavigationModals,
        shouldRenderSecondScreenDetectedModal,
        shouldRenderTalviewInitAllocatedTimePassedModal,
    } = props;

    return (<React.Fragment>
        { shouldRenderOneWayNavigationModals &&
            <React.Fragment>
                <OneWayConfirmationModal />
                <OneWayNavigationOfflineModal />
            </React.Fragment>
        }

        { shouldRenderSecondScreenDetectedModal && <SecondScreenDetectedModal /> }

        { shouldRenderTalviewInitAllocatedTimePassedModal && <TalviewInitAllocatedTimePassedModal /> }

    </React.Fragment>);
};

ModalsContainer.propTypes = {
    shouldRenderOneWayNavigationModals: PropTypes.bool.isRequired,
    shouldRenderSecondScreenDetectedModal: PropTypes.bool.isRequired,
    shouldRenderTalviewInitAllocatedTimePassedModal: PropTypes.bool.isRequired,
};

const mapStateToProps = state => modalsContainerSelector.selectProps(state);
export default connect(mapStateToProps)(ModalsContainer);
